import client from '/src/services/client.js';

export default {
    checkPasswordAvailability : (data) => client.get('user/check-availability', data),
    //getCompaniesOfUser : () => client.get('user/info/company/list'),
    getInformationUser : () => client.get('user/info'),
    updateMyAccount : (data) => client.put(`account/user`, data)
}